import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Hero.css';

const VenuesHero = () => {
  const { t } = useTranslation();

  return (
    <section className="tk-hero">
      <div className="tk-hero-glow tk-hero-glow--accent" aria-hidden="true"></div>
      <div className="tk-hero-glow tk-hero-glow--violet" aria-hidden="true"></div>
      <div className="tk-hero-grid" aria-hidden="true"></div>

      <div className="tk-hero-center">
        <span className="tk-hero-badge">
          <span className="tk-hero-badge-dot" aria-hidden="true"></span>
          {t('venues.hero.badge')}
        </span>

        <h1 className="tk-hero-title">
          {t('venues.hero.title')}{' '}
          <span className="tk-hero-title-highlight">{t('venues.hero.titleHighlight')}</span>
        </h1>

        <p className="tk-hero-subtitle">{t('venues.hero.subtitle')}</p>

        <div className="tk-hero-ctas">
          <a href="#contact" className="tk-btn-primary">
            {t('venues.hero.ctaPrimary')}
          </a>
          <a href="#features" className="tk-btn-ghost">
            {t('venues.hero.ctaSecondary')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default VenuesHero;
